var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarning16(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "warning_24",
    transform: "translate(8137 4408)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_24574",
    "data-name": "Rechteck 24574",
    width: 16,
    height: 16,
    transform: "translate(-8137 -4408)",
    fill: "rgba(102,102,102,0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5559",
    "data-name": "Pfad 5559",
    d: "M15.2157,13.52942,8.88232,1.65442a1,1,0,0,0-1.76464,0L.7843,13.52942A1,1,0,0,0,1.66675,15H14.33337a1,1,0,0,0,.88233-1.47058ZM9,13H7V11H9Zm0-3H7V5H9Z",
    transform: "translate(-8137 -4407.979)",
    fill: "#ff9600"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning16);
export default __webpack_public_path__ + "static/media/Warning_16.b9957aca8e4c978a5fdc8fd2790f904f.svg";
export { ForwardRef as ReactComponent };